import PropTypes from 'prop-types';
import React, { createElement } from 'react';
import { Field } from 'redux-form';
import { withProps } from 'recompose';
import Title from '../Title';
import FormGroup from './Group';
import withScroll from './withScroll';
import { GridLayout } from './layout';
import CheckboxButton from './CheckboxButton';
import Error from '../Error';

const CheckboxGroup = ({ choices, input, meta, title, groupComponent, ...props }) => {
    const checkboxes = Object.entries(choices).map(([key, label]) => (
        <Field
            title={label}
            component={CheckboxButton}
            name={`${input.name}.${key}`}
            key={key}
        />
    ));
    const error = <Error {...meta} />;

    return (
        <FormGroup>
            <Title>{title}</Title>
            {createElement(groupComponent, props, checkboxes, error)}
        </FormGroup>
    );
};

CheckboxGroup.propTypes = {
    choices: PropTypes.objectOf(PropTypes.string.isRequired).isRequired,
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
    }).isRequired,
    meta: PropTypes.shape({
        error: PropTypes.string,
    }).isRequired,
    title: PropTypes.node.isRequired,
    groupComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

CheckboxGroup.defaultProps = {
    groupComponent: GridLayout,
};

const CheckboxQuestionField = withProps({ component: CheckboxGroup })(Field);

const CheckboxQuestion = withScroll(CheckboxQuestionField);

export default CheckboxQuestion;
